<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productosNuevo"
  >
    <form
      autocomplete="off"
      class="m-container-primary"
      @submit.prevent="createProduto"
    >
      <div class="row">
        <div class="column column-6">
          <!-- producto.nombre -->
          <AtomInputPrimary
            v-model="datos.producto.nombre"
            :inputError="$v.datos.producto.nombre.$error"
            :label="'Nombre'"
            :message="'* De 5 a 120 caracteres'"
            :messageError="messageErrorNombre"
            name="nombre"
            :placeholder="'Nombre del Producto'"
            type="text"
            @blur="$v.datos.producto.nombre.$touch()"
            wrapper-class="a-input-wrapper-column"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-6">
          <!-- producto.descripcion -->
          <AtomTextAreaPrimary
            v-model="datos.producto.descripcion"
            :inputError="$v.datos.producto.descripcion.$error"
            :label="'Descripción'"
            :message="'* De 10 a 120 caracteres'"
            :messageError="messageErrorDescripcion"
            name="descripcion"
            @blur="$v.datos.producto.descripcion.$touch()"
          />
        </div>
      </div>

      <div class="row">
        <div class="column column-6">
          <!--tipos_licencia -->
          <AtomSelectPrimary
            v-model.number="tipos_licencia"
            :elements="productosVidroop"
            :inputError="$v.tipos_licencia.$error"
            keyField="nombre"
            :label="'Tipo de Licencia'"
            :messageError="messageErrorTiposDeLicencia"
            name="tipo_licencia"
            textField="nombre"
            @blur="$v.tipos_licencia.$touch()"
          />
        </div>
      </div>
      <div class="row">
        <div class="column column-6">
          <div class="m-card-record-info-licence">
            <div class="m-card-record-info-licence-body">
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.admins') }}
                <span class="font-sim-card-record-infoze-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.administradores}}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.teachers') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.profesores }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                 {{ $t('mEditionBillingProductCreate.info.product.instructors') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.instructores}}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                 {{ $t('mEditionBillingProductCreate.info.product.students') }}
                <span class="font-size-xsmall text-color-black-45"> </span>
              </span>
                <span class="info-text-right">
                {{ datos.vidroop.alumnos }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.assets') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.maps') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.products') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.salesData') }}
                <span class="font-size-xsmall text-color-black-45"> ({{ $t('mEditionBillingProductCreate.info.product.unlimited') }})</span>
              </span>
                <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.mails') }}
                <span class="font-size-xsmall text-color-black-45"></span>
              </span>
                <span class="info-text-right">
                 {{ datos.vidroop.emails }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
               {{ $t('mEditionBillingProductCreate.info.product.academy') }}
              </span>
                <span
                  v-if="datos.vidroop.tipo_universidad"
                  class="info-text-right"
                >
                {{ tipo_universidad[datos.vidroop.tipo_universidad].nombre }}
              </span>
                <span
                  v-else
                  class="info-text-right text-color-black-35">
                  {{ $t('mEditionBillingProductCreate.info.product.not') }}
              </span>
              </p>
              <p>
              <span class="info-text-left">
                {{ $t('mEditionBillingProductCreate.info.product.integrations') }}
              </span>
                <span class="info-icon-right info-icon-billing">
              <i class="fas fa-check"></i>
            </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column column-12">
          <AtomButtonPrimary :button-primary="buttonPrimary"/>
        </div>
      </div>

    <div class="row margin-top-xxlarge">
      <div class="column column-12">
        <p class="font-size-small text-color-success font-weight-bold">
          <i class="far fa-info-circle"></i>
          INFO: Las características cantidad de productos, puntos de venta, proyectos y mapas comenzaron a ser ilimitadas para todas las licencias a partir del día 4/08/2024
        </p>
      </div>
    </div>
    </form>
  </div>
</template>

<script>
import { decimal, integer, maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionBillingProductsCreate',

  data () {
    return {
      buttonPrimary: {
        action: 'CREAR',
        class: 'a-button-billing-primary margin-top-xxlarge',
        sending: false,
        type: 'submit'
      },

      datos: {
        academia: {
          id: ''
        },

        producto: {
          nombre: '',
          descripcion: ''
        },

        vidroop: {
          alumnos: '',
          administradores: '',
          profesores: '',
          instructores: '',
          tipo_universidad: '',
          emails: '',
          comisiones: '',
          integraciones: 0,
          clases_vivo: 0,
          afiliaciones: 0,
          evaluaciones: 0,
          control_alumnos: 0,
          importacion_alumnos: 0
        }
      },

      datos_messageError: {
        producto: {
          nombre: {
            required: 'Nombre del producto es requerido.',
            maxLength: 'La longitud máxima permitida es de 120 caracteres.',
            minLength: 'La longitud mínima permitida es de 5 caracteres.'
          },
          descripcion: {
            required: 'La Descripcion del producto es requerido.',
            maxLength: 'La longitud máxima permitida es de 120 caracteres.',
            minLength: 'La longitud mínima permitida es de 10 caracteres.'
          }
        },

        vidroop: {
          tipos_licencia: {
            required: 'Tipo de Licencia es requerido.'
          },
          tipo_universidad: {
            required: 'Tipo de Universidad es requerido.'
          }
        }
      },

      tipo_universidad: [
        {
          id: 0,
          nombre: 'Mini'
        },

        {
          id: 1,
          nombre: 'Profesional'
        }
      ],

      tipos_licencia: '',

      productosVidroop: [],

      showLoadingState: 0
    }
  },

  validations: {
    datos: {
      producto: {
        nombre: {
          maxLength: maxLength(120),
          minLength: minLength(5),
          required
        },
        descripcion: {
          maxLength: maxLength(120),
          minLength: minLength(10),
          required
        }
      },

      vidroop: {
        tipo_universidad: {
          required
        }
      }
    },
    tipos_licencia: {
      required
    }
  },

  computed: {
    messageErrorNombre () {
      return this.getmessageError(this.$v.datos.producto.nombre, 'producto', 'nombre')
    },

    messageErrorDescripcion () {
      return this.getmessageError(this.$v.datos.producto.descripcion, 'producto', 'descripcion')
    },

    messageErrorTiposDeLicencia () {
      return this.getmessageError(this.$v.tipos_licencia, 'vidroop', 'tipos_licencia')
    }
  },

  watch: {
    tipos_licencia () {
      let product = this.productosVidroop.find(p => p.nombre === this.tipos_licencia)
      for (const param in product) {
        let index = param.replace('maximo_', '')
        if (this.datos.vidroop.hasOwnProperty(index)) {
          this.datos.vidroop[index] = product[param];
        }
      }
    }
  },

  created () {
    this.readProductosVidroop()
    this.datos.academia.id = this.$store.getters.getAcademyData.id
  },

  methods: {
    createProduto () {
      this.$v.$touch()
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('producto', 'createProductoVidroop', this.datos)
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlertNotTranslated('Producto creado exitosamente.', 'a-alert-success')
            this.buttonPrimary.sending = false
            this.$router.push(`/gestion/productos-de-vidroop`)
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlertNotTranslated('Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    getmessageError (fieldVState, field, childField) {
      if (fieldVState.$error) {
        let rules = this.datos_messageError[field][childField]
        for (const rule in rules) {
          if (!fieldVState[rule]) {
            return this.datos_messageError[field][childField][rule]
          }
        }
      }
    },

    readProductosVidroop () {
      this.$services.read('producto', 'readProductosVidroop', this.datos, [], { licencia_default: 1})
        .then(response => {
          this.productosVidroop = response.data
          if (this.productosVidroop.length) {
            this.productosVidroop.sort((a, b) => a.maximo_alumnos - b.maximo_alumnos)
            this.tipos_licencia = this.productosVidroop[0].nombre
          } else {
            this.$alerts.pushAlertNotTranslated('No hay productos vidroop cargados.', 'a-alert-danger')
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlertNotTranslated('Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.', 'a-alert-danger')
          this.buttonPrimary.sending = false
        })
    }
  }
}
</script>
